(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/views/best-rows-list-item.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/views/best-rows-list-item.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.best_rows=_svs.sport.best_rows||{};
_svs.sport.best_rows.templates=_svs.sport.best_rows.templates||{};
svs.sport.best_rows.templates.best_rows_list_item = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "    <div class=\"padding best-row-mark\">\n"
    + ((stack1 = helpers["if"].call(alias1,helpers.lookup.call(alias1,(depths[1] != null ? depths[1].disabledMarks : depths[1]),(data && data.index),{"name":"lookup","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "            <span class=\"btn-bet btn-bet-"
    + alias2(alias1((depths[1] != null ? depths[1].productname : depths[1]), depth0))
    + " btn-bet-100 disabled\">\n            <label class=\"btn-bet-label\">"
    + alias2(alias1(depth0, depth0))
    + "</label>\n            </span>\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "            <span class=\"btn-bet btn-bet-"
    + alias2(alias1((depths[1] != null ? depths[1].productname : depths[1]), depth0))
    + " btn-bet-100 "
    + ((stack1 = helpers["if"].call(alias3,helpers.lookup.call(alias3,(depths[1] != null ? depths[1].hits : depths[1]),(data && data.index),{"name":"lookup","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " \">\n            <label class=\"btn-bet-label\">"
    + alias2(alias1(depth0, depth0))
    + "</label>\n            </span>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "btn-bet-selected";
},"7":function(container,depth0,helpers,partials,data) {
    return "bold";
},"9":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers.corrects || (depth0 != null ? depth0.corrects : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"corrects","hash":{},"data":data}) : helper)));
},"11":function(container,depth0,helpers,partials,data) {
    return "-";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.marks : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"padding best-row-corrects "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isInPriceGroup : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.drawClosed : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true,"useDepths":true});
Handlebars.partials['components-sport-best_rows-best_rows_list_item'] = svs.sport.best_rows.templates.best_rows_list_item;
})(svs, Handlebars);

 })(window);